<template>
  <div class="container">
    <div class="alert alert-danger" v-if="error" role="alert">
      {{ error }}
    </div>
    <form action="post" @submit.prevent="login" :class="{ 'was-validated': submitted }">
      <div class="form-group">
        <label for="username">Användarnamn</label>
        <input type="text" class="form-control" id="username" v-model="username" required>
      </div>

      <div class="form-group">
        <label for="password">Lösenord</label>
        <input type="password" class="form-control" id="password" v-model="password" required>
      </div>

      <button type="submit" class="btn btn-primary" @click="submitted = true">Logga in</button>
    </form>
  </div>
</template>
<script>
export default {
  data () {
    return {
      error: '',
      submitted: false,
      username: '',
      password: ''
    }
  },

  methods: {
    login () {
      this.$store.dispatch('login', { username: this.username, password: this.password })
      .then(() => {
        this.$router.replace('/')
      })
      .catch((err) => {
        this.error = err
        this.password = ''
      })
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/components/Login.vue